/* External */
import { Map } from 'immutable';

/* Ott-common */
import {
  SeasonEntity,
  ShowEntity,
  ChannelEntity,
  CarouselEntity,
  RowAdEntity,
  ContentEntity,
  ScheduleEntity,
} from '@dtvgo/backend-service/normalize';

/* Utils */
import { getPageEntityModel } from '../utils/functions';

import createModel from './utils/createModel';

const PageEntityModel = getPageEntityModel();

export const Season = createModel(SeasonEntity, 'Season');
export const Show = createModel(ShowEntity, 'Show');
export const Channel = createModel(ChannelEntity, 'Channel', {
  /* Schedules merge across fetches: a UNION keyed by the schedule's
     start/end timestamps (the normalized key `startTimestamp_endTimestamp`),
     with refetched programs (identical times) replacing the stored entry.

     The previous implementation was a two-pointer overlap walk that
     DELETED any stored program a refetched one overlapped with, even by a
     single second of time jitter between responses. One refetch whose Bora
     Brasil came back with endTime 11:00:xx (vs 11:00:00) cascaded into
     deleting the adjacent 11:00-12:00 program entirely — the row then had
     no program containing the current time, the snap fell back to the
     stale column and pinned the timeline ~2h in the future: no yellow
     "now" marker, cards "jumping" ahead (the BAND row report). Real
     overlaps are rare (the fetch windows are designed non-overlapping:
     fromDatetime = last endTime + 1s), and when they do occur keeping both
     is faithful to the API; deleting real adjacent programs is not. */
  schedules: (oldVal, newVal) => {
    if (!newVal) return oldVal;

    const newCreatedVal = Map(newVal).sortBy((scheduleId, key) => +(key.split('_')[0]));
    if (!oldVal) return newCreatedVal;

    return oldVal.mergeWith((oldScheduleId, newScheduleId) => newScheduleId, newCreatedVal)
      .sortBy((scheduleId, key) => +(key.split('_')[0]));
  },
});
export const Schedule = createModel(ScheduleEntity, 'Schedule');
export const Page = createModel(PageEntityModel, 'Page');
export const Content = createModel(ContentEntity, 'Content');
export const Carousel = createModel(CarouselEntity, 'Carousel');
export const RowAd = createModel(RowAdEntity, 'RowAd');
